import { normalizeBrowserPathname } from '~/utils/route'

const syncReadableUrl = () => {
  const { pathname, search, hash } = window.location
  const readablePathname = normalizeBrowserPathname(pathname)

  if (readablePathname === pathname) return

  window.history.replaceState(
    window.history.state,
    '',
    `${readablePathname}${search}${hash}`,
  )
}

export default defineNuxtPlugin(() => {
  const route = useRoute()

  onNuxtReady(() => {
    syncReadableUrl()

    watch(
      () => route.fullPath,
      () => {
        syncReadableUrl()
      },
    )
  })
})
